<template>
  <div class="head">
    <div class="top">
      <div class="top-box">
        <div class="flex homeSkip" @click="homeSkip">
          <img class="logoImg" src="../../assets/logoImg.png" alt="" />
          <div class="kbl">江西科泊乐智能科技有限公司</div>
        </div>
        <div class="flex">
          <div class="top-tit">
            <router-link to="/" class="tit" :class="showBorder == 1 ? 'borders': ''">
              首页
            </router-link>
          </div>
          <div class="top-tit">
            <router-link to="/ourselves" class="tit" :class="showBorder == 2 ? 'borders': ''">
              关于我们
            </router-link>
          </div>
          <div class="top-tit">
            <router-link to="/solution" class="tit" :class="showBorder == 3 ? 'borders': ''">
              解决方案
            </router-link>
          </div>
          <div class="top-tit">
            <router-link to="/contact" class="tit" :class="showBorder == 4 ? 'borders': ''">
              联系我们
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  props:['showBorder'],
  created(){
  },
  methods:{
    homeSkip(){
      this.$router.push({path:'/'});
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.kbl{
  font-family: 'Avenir';
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 22px;
  color: #FFFFFF;
}
.homeSkip{
  cursor:pointer
}
.borders{
  border-bottom: 1px solid #fff;
  padding-bottom: 15px;
}
.top-tit-border{
  width: 32px;
  height: 1px;
  background-color: #fff;
  position: absolute;
  left: 2px;
  bottom: 0px;
}
.top-tit{
  position: relative;
}
a {
  text-decoration: none;
}
.tit {
  color: #fff;
}
.head {
  position: fixed;
  width: 100%;
}
.flex div {
  margin-right: 64px;
}
.flex div:nth-child(4) {
  margin-right: 0px;
}
.logoImg {
  width: 27px;
  height: 15.52px;
  margin-right: 8px;
}
.top-box {
  display: flex;
  height: 100%;
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #FFFFFF;
  justify-items: center;
  justify-content: space-between;
}
.top {
  flex: 1;
  background: rgba(7, 1, 48, 0.16);
  height: 56px;
  padding: 0px 156px;
}
</style>



// WEBPACK FOOTER //
// src/view/module/head.vue